module.exports = __webpack_public_path__ + "static/img/loading.c8c723b9.gif";